import { RemoteDeviceType } from '@store';
import {
  CommissioningStrategyFactory,
  airQualitySensorStrategy,
  csRepeaterStrategy,
  csStrategy,
  eTRVStandaloneStrategy,
  eTRVStrategy,
  eTRVStrategyOBNG,
  fhtStandaloneStrategy,
  fhtStrategy,
  fhtStrategyOBNG,
  repeaterStrategy,
  vicareThermostatCsRepeaterStrategy,
  vicareThermostatCsStrategyStrategy,
  vicareThermostatRepeaterStrategy,
  vicareThermostatVitotrol_100E,
  vicareThermostatVitotrol_300E,
  vicareThermostatVitotrol_300E_OBNG,
} from './commissioning.strategy';

export enum ROOMS_FILTER_TYPE {
  ALL = 'ALL',
  ASSIGNED = 'ASSIGNED',
  UNASSIGNED = 'UNASSIGNED',
}

export interface Device {
  type: RemoteDeviceType;
  name: string;
  icon: string;
  info?: string;
  strategy?: CommissioningStrategyFactory;
}

export enum ModalAction {
  Close = 'close',
  NextStep = 'nextStep',
  PreviousStep = 'previousStep',
  NavigateToStart = 'navigateToStart',
  NavigateToDeviceAssign = 'navigateToDeviceAssign',
  NavigateToReadyToConnect = 'navigatetoReadyToConnect',
  NavigateToFinalStep = 'navigateToFinalStep',
}

export const DEVICES_TO_COMMISSIONING: Device[] = [
  {
    type: RemoteDeviceType.TRV,
    name: '+COMMISSIONING.DEVICE.ETRV',
    icon: 'commissioning-thermostat',
    strategy: eTRVStrategy,
  },
  {
    type: RemoteDeviceType.CS,
    name: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR',
    icon: 'commissioning-climate-sensor',
    info: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR_INFO_SUBTEXT',
    strategy: csStrategy,
  },
  {
    type: RemoteDeviceType.CS_REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER_WALL',
    icon: 'commissioning-repeater-wall',
    info: '+COMMISSIONING.DEVICE.REPEATER_WALL_INFO_SUBTEXT',
    strategy: csRepeaterStrategy,
  },
  {
    type: RemoteDeviceType.REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER',
    icon: 'commissioning-repeater-behind-wall',
    strategy: repeaterStrategy,
  },
  {
    type: RemoteDeviceType.FHT,
    name: '+COMMISSIONING.DEVICE.FLOOR_HEATING_THERMOSTAT',
    icon: 'commissioning-fht',
    strategy: fhtStrategy,
  },
  {
    type: RemoteDeviceType.AIR_QUALITY_SENSOR,
    name: '+COMMISSIONING.DEVICE.AIR_QUALITY_SENSOR',
    icon: 'commissioning-air-quality-sensor',
    info: '+COMMISSIONING.DEVICE.AIR_QUALITY_SENSOR_SUBTEXT',
    strategy: airQualitySensorStrategy,
  },
  {
    type: RemoteDeviceType.VITOTROL_300E,
    name: '+COMMISSIONING.DEVICE.VITOTROL_300E',
    icon: 'commissioning-remote-controller-vitotrol-300E',
    strategy: vicareThermostatVitotrol_300E,
  },
];

export const DEVICES_TO_COMMISSIONING_IN_VICARE_THERMOSTAT_MODE: Device[] = [
  {
    type: RemoteDeviceType.CS_REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER_WALL',
    icon: 'commissioning-repeater-wall',
    info: '+COMMISSIONING.DEVICE.REPEATER_WALL_INFO_SUBTEXT',
    strategy: vicareThermostatCsRepeaterStrategy,
  },
  {
    type: RemoteDeviceType.CS,
    name: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR',
    icon: 'commissioning-climate-sensor',
    info: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR_INFO_SUBTEXT',
    strategy: vicareThermostatCsStrategyStrategy,
  },
  {
    type: RemoteDeviceType.REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER',
    icon: 'commissioning-repeater-behind-wall',
    strategy: vicareThermostatRepeaterStrategy,
  },
  {
    type: RemoteDeviceType.VITOTROL_100E,
    name: '+COMMISSIONING.DEVICE.VITOTROL_100E',
    icon: 'commissioning-remote-controller-vitotrol',
    strategy: vicareThermostatVitotrol_100E,
  },
];

export const DEVICES_TO_COMMISSIONING_FOR_STANDALONE_INSTALLATION: Device[] = [
  {
    type: RemoteDeviceType.TRV,
    name: '+COMMISSIONING.DEVICE.ETRV',
    icon: 'commissioning-thermostat',
    strategy: eTRVStandaloneStrategy,
  },
  {
    type: RemoteDeviceType.CS,
    name: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR',
    icon: 'commissioning-climate-sensor',
    info: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR_INFO_SUBTEXT',
    strategy: csStrategy,
  },
  {
    type: RemoteDeviceType.CS_REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER_WALL',
    icon: 'commissioning-repeater-wall',
    info: '+COMMISSIONING.DEVICE.REPEATER_WALL_INFO_SUBTEXT',
    strategy: csRepeaterStrategy,
  },
  {
    type: RemoteDeviceType.REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER',
    icon: 'commissioning-repeater-behind-wall',
    strategy: repeaterStrategy,
  },
  {
    type: RemoteDeviceType.FHT,
    name: '+COMMISSIONING.DEVICE.FLOOR_HEATING_THERMOSTAT',
    icon: 'commissioning-fht',
    strategy: fhtStandaloneStrategy,
  },
  {
    type: RemoteDeviceType.AIR_QUALITY_SENSOR,
    name: '+COMMISSIONING.DEVICE.AIR_QUALITY_SENSOR',
    icon: 'commissioning-air-quality-sensor',
    info: '+COMMISSIONING.DEVICE.AIR_QUALITY_SENSOR_SUBTEXT',
    strategy: airQualitySensorStrategy,
  },
  {
    type: RemoteDeviceType.VITOTROL_300E,
    name: '+COMMISSIONING.DEVICE.VITOTROL_300E',
    icon: 'commissioning-remote-controller-vitotrol-300E',
    strategy: vicareThermostatVitotrol_300E,
  },
];

export const DEVICES_TO_COMMISSIONING_FOR_OBNG_STANDALONE_INSTALLATION: Device[] = [
  {
    type: RemoteDeviceType.TRV,
    name: '+COMMISSIONING.DEVICE.ETRV',
    icon: 'commissioning-thermostat',
    strategy: eTRVStrategyOBNG,
  },
  {
    type: RemoteDeviceType.CS,
    name: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR',
    icon: 'commissioning-climate-sensor',
    info: '+COMMISSIONING.DEVICE.CLIMATE_SENSOR_INFO_SUBTEXT',
    strategy: csStrategy,
  },
  {
    type: RemoteDeviceType.CS_REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER_WALL',
    icon: 'commissioning-repeater-wall',
    info: '+COMMISSIONING.DEVICE.REPEATER_WALL_INFO_SUBTEXT',
    strategy: csRepeaterStrategy,
  },
  {
    type: RemoteDeviceType.REPEATER,
    name: '+COMMISSIONING.DEVICE.REPEATER',
    icon: 'commissioning-repeater-behind-wall',
    strategy: repeaterStrategy,
  },
  {
    type: RemoteDeviceType.FHT,
    name: '+COMMISSIONING.DEVICE.FLOOR_HEATING_THERMOSTAT',
    icon: 'commissioning-fht',
    strategy: fhtStrategyOBNG,
  },
  {
    type: RemoteDeviceType.AIR_QUALITY_SENSOR,
    name: '+COMMISSIONING.DEVICE.AIR_QUALITY_SENSOR',
    icon: 'commissioning-air-quality-sensor',
    info: '+COMMISSIONING.DEVICE.AIR_QUALITY_SENSOR_SUBTEXT',
    strategy: airQualitySensorStrategy,
  },
  {
    type: RemoteDeviceType.VITOTROL_300E,
    name: '+COMMISSIONING.DEVICE.VITOTROL_300E',
    icon: 'commissioning-remote-controller-vitotrol-300E',
    strategy: vicareThermostatVitotrol_300E_OBNG,
  },
];

export const DEVICES_TO_COMMISSIONING_FOR_SYSTEM_OVERLAY: Device[] = [
  {
    type: RemoteDeviceType.VITOTROL_300E,
    name: '+COMMISSIONING.DEVICE.VITOTROL_300E',
    icon: 'commissioning-remote-controller-vitotrol-300E',
    strategy: vicareThermostatVitotrol_300E,
  },
];
